<se-fe-grid [formGroup]="paymentTermForm" seFeGridOpts="snug">
  <se-fe-grid-cell seFeGridOpts="1/2@mobile 1/4@tablet" class="upfront-form">
    <se-fe-form-field [seFeDataConfig]="upfrontAmountFieldConfig">
      <se-fe-form-field-text
        seFeDataAutoComplete="off"
        (blur)="setStatusAndFormatAmount()"
        (focus)="setUpfrontAmountFocus()"
        formControlName="upfrontAmount"
        seFeDataPlaceholder="0.00">
        <se-fe-icon seFeFormFieldTextBefore seFeDataName="dollar" seFeDataSize="500"></se-fe-icon>
      </se-fe-form-field-text>
    </se-fe-form-field>
  </se-fe-grid-cell>
  <se-fe-grid-cell seFeGridOpts="shrink@mobile">
    <se-fe-button
      [seFeDataEmphasis]="'medium'"
      (mousedown)="applyUpfrontAmount($event)">
      {{'PAYMENT_TERMS_SELECTOR.UPFRONT_PAYMENT.apply_button_text' | translate }}
    </se-fe-button>
  </se-fe-grid-cell>
  @if (upfrontAmountControl.valid && applied === false) {
<se-fe-alert seFeDataType="error">
    {{ 'PAYMENT_TERMS_SELECTOR.UPFRONT_PAYMENT.ERRORS.apply' | translate }}
  </se-fe-alert>
}
</se-fe-grid>
